import React, { useEffect, Component } from "react";
import { Link } from 'react-router-dom';
import WithConsumer from '../context/WithConsumer';

const CollectionFilters = ({context}) => {
	
	const posts = () => context.posts;
    const item = posts()[0];
        
    const activeFiltersCtx = () => context.filters;
    const activeFilters = activeFiltersCtx();
    
    const ctxUser = () => context.user;
	const user = ctxUser();
	
	useEffect(() => {
		try {
			if (activeFilters.designer.length > 0) {
				document.getElementsByClassName('c-filters__toggle-list__link--designer')[0].click();
			} else if (activeFilters.product_cat.length > 0) {
				document.getElementsByClassName('c-filters__toggle-list__link--product_cat')[0].click();
			} else if (activeFilters.finish.length > 0) {
				document.getElementsByClassName('c-filters__toggle-list__link--finish')[0].click();
			}
		} catch (error) {
			//console.error(error);
		}
	}, []);
  
	let loggedIn = true;
	if (user.id === false || user.id === 'false' || user.id === null) {
		loggedIn = false;
	}

	const activeFilterMenuCtx = () => context.filterMenu;
    let activeFilterMenu = activeFilterMenuCtx();
    
    let filterText = '';
    
    let fullCurrentUrl = window.location + '';
    let currentUrl = window.location.pathname + '';
        
    if (!activeFilterMenu) {
	    activeFilterMenu = 'null';
    }
        
    function toggleMenu(event) {
	    event.preventDefault();
	    let menu = event.currentTarget.getAttribute('data-menu');
	    if (activeFilterMenu === menu) {
			activeFilterMenu = null;
	    } else {
		    activeFilterMenu = menu;
	    }
	    context.changeFilterMenu(activeFilterMenu);
	}
	
	function clearAll(event) {
		event.preventDefault();
		
		activeFilters.designer = [];
		activeFilters.product_cat = [];
		activeFilters.finish = [];
		
		context.changeFilters(activeFilters);
		
		setTimeout(function(){
			window.scrollTo(window.scrollX, window.scrollY + 1);
		}, 100);
	}
	
	function clearFilter(event) {
		event.preventDefault();
		
		let type = event.target.getAttribute('data-type');
		
		if (type === 'designer') {
			activeFilters.designer = [];
		}
		
		if (type === 'product_cat') {
			activeFilters.product_cat = [];
		}
		
		if (type === 'finish') {
			activeFilters.finish = [];
		}
		
		context.changeFilters(activeFilters);
		setTimeout(function(){
			window.scrollTo(window.scrollX, window.scrollY + 1);
		}, 100);
	}
	
    function toggleFilter(event) {
	    event.preventDefault();
		
		let type = event.target.getAttribute('data-type');
		let id = parseInt(event.target.getAttribute('data-id'));
		let index = 0;
				
		if (type === 'designer') {
			if (activeFilters.designer.includes(id)) {
				index = activeFilters.designer.indexOf(id);
				if (index > -1) {
					activeFilters.designer.splice(index, 1);
				}
			} else {
				activeFilters.designer.push(id);
			}
		}
		
		if (type === 'product_cat') {
			if (activeFilters.product_cat.includes(id)) {
				index = activeFilters.product_cat.indexOf(id);
				if (index > -1) {
					activeFilters.product_cat.splice(index, 1);
				}
			} else {
				activeFilters.product_cat.push(id);
			}
		}
		
		if (type === 'finish') {
			if (activeFilters.finish.includes(id)) {
				index = activeFilters.finish.indexOf(id);
				if (index > -1) {
					activeFilters.finish.splice(index, 1);
				}
			} else {
				activeFilters.finish.push(id);
			}
		}
		
		context.changeFilters(activeFilters);
		setTimeout(function(){
			window.scrollTo(window.scrollX, window.scrollY + 1);
		}, 100);
	}
		
    function getQueryVariable(variable) {
	    var query = window.location.search.substring(1);
	    var vars = query.split('&');
	    for (var i = 0; i < vars.length; i++) {
	        var pair = vars[i].split('=');
	        if (decodeURIComponent(pair[0]) == variable) {
	            return decodeURIComponent(pair[1]);
	        }
	    }
	}
	
	function GetAllFilterItem(ids, type) {
		if (ids.length > 0) {
			return (<li className="c-filters__list__item"><a href="#" className="c-filters__list__link" data-type={type} onClick={clearFilter}>All</a></li>)
		} else {
			return (<li className="c-filters__list__item"><a href="#" className="c-filters__list__link state-active" data-type={type} onClick={clearFilter}>All</a></li>)
		}
	}
	
	function GetFilterItem(filter, key) {
		if (activeFilters.designer.includes(parseInt(filter.id)) || activeFilters.product_cat.includes(parseInt(filter.id)) || activeFilters.finish.includes(parseInt(filter.id))) {
			return (<li key={key} className="c-filters__list__item"><a href="#" className="c-filters__list__link state-active" data-id={filter.id} data-type={filter.type} onClick={toggleFilter} dangerouslySetInnerHTML={ {__html: filter.name} }></a></li>)
		} else {
			return (<li key={key} className="c-filters__list__item"><a href="#" className="c-filters__list__link" data-id={filter.id} data-type={filter.type} onClick={toggleFilter} dangerouslySetInnerHTML={ {__html: filter.name} }></a></li>)
		}
	}
		
	if (item.filters) {
				  		
  		let i = 0;
  		let j = 0;		
		let designers = false;
		let productCats = false;
		let finishes = false;
		
		let doFilters = false;
		
		if (item.filters.designer) {
			if (item.filters.designer.length > 1) {
				doFilters = true;
				designers = item.filters.designer.map((filter,i) =>
					GetFilterItem(filter,i)	
				)
			}
		}
		
		if (item.filters.product_cat) {
			
			if (item.filters.product_cat.length > 1) {
				doFilters = true;
				productCats = item.filters.product_cat.map((filter,i) =>
					GetFilterItem(filter,i)	
				)
			}
		}
		
		if (item.filters.finish) {
			
			if (item.filters.finish.length > 1) {
				doFilters = true;
				finishes = item.filters.finish.map((filter,i) =>
					GetFilterItem(filter,i)	
				)
			}
		}
			
		if (doFilters === true) {	
				
		    return (
		    		    	
			    	<div className="l-grid">
			    	
						<div className="l-grid__col">
							
							<div className={'c-filters state-menu-' + activeFilterMenu}>
								
								<div className="c-filters__left">
									<ul className="c-filters__toggle-list">
										<li className="c-filters__toggle-list__item">Filter by</li>
										{designers &&
											<li className="c-filters__toggle-list__item">
												<a href="#" className="c-filters__toggle-list__link c-filters__toggle-list__link--designer" data-menu="designer" onClick={toggleMenu}>Designer</a>
											</li>
										}
										{productCats &&
											<li className="c-filters__toggle-list__item">
												<a href="#"  className="c-filters__toggle-list__link c-filters__toggle-list__link--product_cat" data-menu="product_cat" onClick={toggleMenu}>Collections</a>
											</li>
										}
										{finishes &&
											<li className="c-filters__toggle-list__item">
												<a href="#"  className="c-filters__toggle-list__link c-filters__toggle-list__link--finish" data-menu="finish" onClick={toggleMenu}>Finishes</a>
											</li>
										}
										{item.stock_label == 'instock' &&
											<li className="c-filters__toggle-list__item">
												<Link to={currentUrl + '?stock=instock'} className="c-filters__toggle-list__link state-active">Instock</Link>
											</li>
										}
										{item.stock_label != 'instock' &&
											<li className="c-filters__toggle-list__item">
												<Link to={currentUrl + '?stock=instock'} className="c-filters__toggle-list__link">Instock</Link>
											</li>
										}
										{(activeFilters.designer.length !== 0 || activeFilters.product_cat.length !== 0 || activeFilters.finish.length !== 0) &&
											<li className="c-filters__toggle-list__item">
												<a href="#"  className="c-filters__toggle-list__link" onClick={clearAll}>Reset</a>
											</li>
										}
										{loggedIn === true &&
											<li className="c-filters__toggle-list__item">
												{item.sort == 'price-low-high' &&
													<Link to={currentUrl + '?sort=price-low-high'} className="c-filters__toggle-list__link c-filters__toggle-list__link--product_cat state-active">Price low to high</Link>
												}
												{item.sort != 'price-low-high' &&
													<Link to={currentUrl + '?sort=price-low-high'} className="c-filters__toggle-list__link c-filters__toggle-list__link--product_cat">Price low to high</Link>
												}
											</li>
										}
									</ul>
								</div>
								
								{designers &&
									<ul id="filter-designer" className="c-filters__list">
										{ GetAllFilterItem(activeFilters.designer, "designer") }
										{ designers }
									</ul>
								}
								{productCats &&
									<ul id="filter-product_cat" className="c-filters__list">
										{ GetAllFilterItem(activeFilters.product_cat, "product_cat") }
										{ productCats }
									</ul>
								}
								{finishes &&
									<ul id="filter-finish" className="c-filters__list">
										{ GetAllFilterItem(activeFilters.finish, "finish") }
										{ finishes }
									</ul>
								}
								
							</div>
			    	
						</div>
						
					</div>
			    
			)
			
		} else {
		
			return null;
		
		}
		
	} else {
		
		return null;
		
	}

}
export default WithConsumer(CollectionFilters);